"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const DeviceTypeContext_types_1 = require("./DeviceTypeContext.types");
function getDeviceType(detector) {
    if (detector.tablet()) {
        return DeviceTypeContext_types_1.DeviceType.Tablet;
    }
    else if (detector.mobile()) {
        return DeviceTypeContext_types_1.DeviceType.Mobile;
    }
    else {
        return DeviceTypeContext_types_1.DeviceType.Desktop;
    }
}
exports.default = getDeviceType;
//# sourceMappingURL=getDeviceType.js.map